<template>
  <div :class="{ 'fade modal-open' : isModalOpen }" class="modal in" @click.self.stop="closeModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal__header" :class="headerClasses">
          <div class="modal__header--angles">
            <img class="modal__profile-pic" :src="item.headshot">
            <div class="modal__contact-name">{{ item.fullName }}</div>
            <div class="modal__contact-position">{{ item.title }}</div>

            <div class="modal__contact-row">
              <div class="modal__contact-phone">{{ item.phone }}</div>
              <div class="modal__contact-separator">|</div>
              <div class="modal__contact-email">{{ item.email }}</div>
            </div>
            <div class="modal__close-btn">
              <i class="fa fa-times" @click="closeModal"></i>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <textarea class="modal__comment-block" placeholder="Send a message..." v-model="text"></textarea>
        </div>
        <div class="modal__footer">
          <div class="modal__sending-overlay" v-if="isSending">
            <moon-loader size="25px" color="#1176BB"></moon-loader>
          </div>
          <div class="modal__send-btn" @click="sendMessage" v-else>Send</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MoonLoader from 'vue-spinner/dist/vue-spinner.min';

  export default {
    name: 'ContactTeamModal',
    components: {
      MoonLoader,
    },
    data() {
      return {
        text: '',
      };
    },
    props: {
      item: {},
      modalKey: '',
      headerClass: '',
    },
    mounted() {
      const component = this;
      this.handler = function (e) {
        if (e.code === 'Escape') {
          component.closeModal();
        }
      }
      window.addEventListener('keyup', this.handler);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.handler);
    },
    computed: {
      ...mapGetters('main', ['displayedModal', 'loaders']),
      isModalOpen() {
        return this.displayedModal === this.modalKey;
      },
      headerClasses() {
        return `modal__header--${this.headerClass}`;
      },
      isSending() {
        return this.loaders.sendingMessage;
      }
    },
    methods: {
      /**
       *  Sends message from member to the back-end server.
       */
      async sendMessage() {
        if (this.text) {
          this.$store.dispatch('main/sendMessage', {
            message: this.text,
            email: this.item.email,
            messageType: 'Member Inquiry',
          });
          await this.closeModal();
        }
      },
      closeModal() {
        this.$store.dispatch('main/showModal', null);
      },
    },
  };
</script>
